<script>
import Button2 from '@/components/ui/Button2';
import { FormControl, FormLabel, FormElement, FormWrapper, FormError } from '@/components/ui/forms';
import UiInput from '@/components/ui/forms/UiInput';
import { BFormCheckbox } from 'bootstrap-vue';
import UiCard from '@/components/ui/Card';
import ChannelItem from "@/components/watchmen/channels/ChannelItem";
import { check_rules } from "@/components/watchmen/channels/ChannelsIndicator/check-rules";

export default {
  name: "ShiftCardCompact",
  components: {
    Button2,
    ChannelItem,
    FormControl,
    FormLabel,
    FormElement,
    FormWrapper,
    FormError,
    UiInput,
    BFormCheckbox,
    UiCard,
  },
  props: {
    value: {
      type: Object,
    }
  },
  data() {
    return {
      shift: this.formatShift(this.value)
    };
  },
  methods: {
    check_rules,
    formatShift(shift) {
      return {
        channels: {
          email: [],
          sms: [],
          tts: []
        },
        ...shift
      };
    },
    dayName: function (day) {
      return [
        window.V.$i18n.t("global.sunday"),
        window.V.$i18n.t("global.monday"),
        window.V.$i18n.t("global.tuesday"),
        window.V.$i18n.t("global.wednesday"),
        window.V.$i18n.t("global.thursday"),
        window.V.$i18n.t("global.friday"),
        window.V.$i18n.t("global.saturday")
      ][day]
    },
    dateFormatLong(date) {
      return new Date(date).toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
    },
    timeFormatHourMin(time) {
      const timeSplited = time.split(':')
      return timeSplited[0] + ':' + timeSplited[1]
    },
    handleEditShift() {
      this.$emit("edit-shift")
    },
    handleActiveChange(active) {
      this.$emit("active-change", { id: this.shift.id, active });
    },
    watchColorClass(status) {
      switch (status) {
        case 'low':
          return 'text-warning'
        case 'none':
          return 'text-danger'
        default:
          return ''
      }
    },
  },
  computed: {
    europeanWeek() {
      return [1, 2, 3, 4, 5, 6, 0]
    },
    daysSorted() {
      return [...this.shift.days].sort((a, b) => this.europeanWeek.indexOf(a) - this.europeanWeek.indexOf(b))
    },
    timeDifference() {
      function twoDigitNumber(num) {
        return num < 10 ? '0' + num : num
      }
      if (!this.shift.time_start || !this.shift.time_end) {
        return ''
      }
      const start = this.shift.time_start.split(':');
      const end = this.shift.time_end.split(':')
      let hours = end[0] - start[0]
      let minutes = end[1] - start[1]
      if (minutes < 0) {
        minutes += 60
        hours -= 1
      }
      if (hours < 0) {
        hours += 24
      }
      if (minutes === 0 && hours === 0) {
        return '24h00'
      }
      return twoDigitNumber(hours) + 'h' + twoDigitNumber(minutes)
    },
    watchRules() {
      return this.check_rules(this.shift.channels)
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.shift = this.formatShift(newVal);
      },
      deep: true
    }
  },
}
</script>

<template>
  <UiCard :style="{ 'background-color': shift.active ? null : 'var(--colors-gray-100) !important' }">
    <div class="d-flex align-items-center mb-3">
      <div class="handle mr-2 px-1">
        <i class="fa fa-arrows fa-fw mr-1" aria-hidden="true"></i>
      </div>
      <h3 v-text="shift.name" class="mb-0"></h3>
      <BFormCheckbox
        v-model="shift.active"
        name="check-button"
        switch
        class="ml-auto"
        :aria-label="$t('watches.active_shift')"
        @change="handleActiveChange"
      />
    </div>
    <div style="display: flex; flex-direction: column; gap: .33rem;" :style="{ opacity: shift.active ? 1 : .5 }">
      <div v-if="shift.dates_active" class="capitalize-first-letter">
        <strong>{{ dateFormatLong(shift.date_start) }}</strong> &rarr;
        <strong>{{ dateFormatLong(shift.date_end) }}</strong>
      </div>

      <div v-if="shift.days.length > 0 && shift.days.length < 7">
        <i class="fa fa-calendar fa-fw mr-1" aria-hidden="true"></i> <span v-for="day in daysSorted">
          {{ dayName(day) }}<template v-if="day !== shift.days[shift.days.length - 1]">, </template>
        </span>
      </div>
      <div v-if="shift.days.length === 7">
        <i class="fa fa-calendar fa-fw mr-1" aria-hidden="true"></i> <span>{{ $t('watches.every_day') }}</span>
      </div>
      <div v-if="shift.days.length === 0">
        <span class="text-danger"> <i class="fa fa-calendar fa-fw mr-1" aria-hidden="true"></i>{{
          $t('watches.no_days')
        }}</span>
      </div>

      <div>
        <i class="fa fa-clock-o fa-fw mr-1" aria-hidden="true"></i>
        <span>{{ timeFormatHourMin(shift.time_start) }}</span> &rarr;
        <span>{{ timeFormatHourMin(shift.time_end) }}</span>
        ({{ timeDifference }})
      </div>

      <div>
        <i class="fa fa-user-circle-o fa-fw mr-1" :class="watchColorClass(watchRules.status)" aria-hidden="true"></i>
        <span v-if="watchRules.watchmen.length > 0">
          <strong>{{ watchRules.watchmen.length }} :</strong>
          <span v-for="watchman in watchRules.watchmen" :key="watchman.id">
            <span class="d-inline-block px-1">{{ watchman.name }}</span><template
              v-if="watchman !== watchRules.watchmen[watchRules.watchmen.length - 1]"> &bull; </template>
          </span> </span>
        <span v-else class="text-danger">
          {{ $t('watches.no_watchmen') }}
        </span>
      </div>
    </div>

    <div class="d-flex">
      <Button2 @click.native.prevent="handleEditShift()" class="btn-sm ml-auto">{{ $t('global.edit') }}</Button2>
    </div>

  </UiCard>
</template>


<style lang="scss">
.ghost {
  opacity: 0.67;
  background-color: var(--colors-gray-100) !important;
}
.handle {
  cursor: move;
}
</style>